export const ASSISTANT_REF_ATTR = 'data-assistant-ref';

export const ASSISTANT_REF_IDS = {
  member: {
    profile: 'member.profile',
    nextBooking: 'member.next-booking',
    planBilling: 'member.plan-billing',
    usage: 'member.usage',
    dropIn: 'member.drop-in',
    penalties: 'member.penalties',
    activity: 'member.activity',
    bookings: 'member.bookings',
    waivers: 'member.waivers',
  },
  lead: {
    details: 'lead.details',
    crmSync: 'lead.crm-sync',
    activity: 'lead.activity',
    bookings: 'lead.bookings',
  },
  location: {
    info: 'location.info',
    boxPro: 'location.box-pro',
    taxRates: 'location.tax-rates',
    startDates: 'location.start-dates',
    qrCodes: 'location.qr-codes',
    integrations: 'location.integrations',
  },
} as const;

const CATALOGUE: ReadonlySet<string> = new Set(
  Object.values(ASSISTANT_REF_IDS).flatMap((group) => Object.values(group)),
);

const OBJECT_ID = /^[a-f0-9]{24}$/i;
const DYNAMIC_ACTIVITY = /^(member|lead)\.activity\.[a-f0-9]{24}$/;

export function activityRefId(entity: 'member' | 'lead', id: string): string | undefined {
  if (typeof id !== 'string' || !OBJECT_ID.test(id)) return undefined;
  return `${entity}.activity.${id.toLowerCase()}`;
}

export function isValidAssistantRefId(id: unknown): boolean {
  if (typeof id !== 'string' || id.length === 0) return false;
  return CATALOGUE.has(id) || DYNAMIC_ACTIVITY.test(id);
}

export function findAssistantRefElements(targetId: string): HTMLElement[] {
  if (!isValidAssistantRefId(targetId)) return [];
  return Array.from(document.querySelectorAll<HTMLElement>('[data-assistant-ref]')).filter(
    (el) => el.getAttribute('data-assistant-ref') === targetId,
  );
}
